import { render } from "./AwardWinningAgency.vue?vue&type=template&id=01422384&scoped=true"
import script from "./AwardWinningAgency.vue?vue&type=script&lang=js"
export * from "./AwardWinningAgency.vue?vue&type=script&lang=js"

import "./AwardWinningAgency.vue?vue&type=style&index=0&id=01422384&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01422384"]])

export default __exports__